import React, { useEffect, useState } from "react";
import { useLocation } from "@reach/router";
import HomeIcon from "./icons/home";
import Chevron from "./icons/chevron";

const Breadcrumb = ({ settings }) => {
  const location = useLocation();
  const [allPaths, setAllPaths] = useState([]);

  useEffect(() => {
    // Fetch the page-paths.json file
    fetch("/page-paths.json")
      .then((response) => {
        if (!response.ok) {
          // If the response is not OK (e.g., 404), throw an error to trigger the catch block
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setAllPaths(data);
      })
      .catch((error) => {
        console.error("Error fetching page paths:", error);
        setAllPaths([]);
      });
  }, []);

  if (settings.hideBreadcrumb) {
    return null;
  }

  // Build the breadcrumbs
  const breadcrumbs = [];
  let pathAccumulator = "";

  //parentPages: [{
  //  slug: "path", // so it needs to be "/path"
  //  title: "text"
  //}]
  if (settings.parentPages && settings.parentPages.length !== 0) {
    settings.parentPages.forEach((parentPage) => {
      breadcrumbs.push({ path: "/" + parentPage.slug, label: parentPage.title });
    });
  } else if (Array.isArray(allPaths) && allPaths.length !== 0) {
    // Optionally render a loading state
    // Split the current path into segments
    const pathSegments = location.pathname.split("/").filter((segment) => segment !== "");

    for (let i = 0; i < pathSegments.length; i++) {
      pathAccumulator += `/${pathSegments[i]}`;

      // Normalize path (ensure it ends with a slash)
      const normalizedPath = pathAccumulator.endsWith("/") ? pathAccumulator : `${pathAccumulator}/`;

      // Check if the path exists in allPaths
      // reports error: allPaths.includes is not a function
      if (allPaths.includes(normalizedPath)) {
        breadcrumbs.push({ path: normalizedPath, label: pathSegments[i].replace(/-/g, " ") });
      } else {
        // Optionally handle cases where the path doesn't exist
        // For example, you might still want to include it but not make it a link
        breadcrumbs.push({ path: null, label: pathSegments[i].replace(/-/g, " ") });
      }
    }
  } else {
    return null;
  }

  // Now render the breadcrumbs
  return (
    <div className="breadcrumb">
      <a className="breadcrumb__link breadcrumb__home-link" href="/">
        <HomeIcon className="breadcrumb__home-icon" />
        <span className="sr-only">Homepage</span>
      </a>
      <Chevron className="breadcrumb__chevron" />

      {breadcrumbs.map((crumb, index) => (
        <React.Fragment key={crumb.path || index}>
          {crumb.path && crumb.path !== location.pathname ? (
            <>
              <a className="breadcrumb__link" href={crumb.path}>
                {crumb.label}
              </a>
              {index < breadcrumbs.length && <Chevron className="breadcrumb__chevron" />}
            </>
          ) : null}
        </React.Fragment>
      ))}
    </div>
  );
};

export default Breadcrumb;
